import {addCompanyToRedux} from '@/redux-store/slices/admin/companies';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';
import {Company} from '@/types/company';

export const addCompany = (formValues: Company) => {
  return keycloakAxios
    .post('admin/company/', formValues, {})
    .then((response) => {
      if (response.status >= 300) {
        throw new Error(
          `Error adding company: Invalid status code: ${response.status}`
        );
      }

      store.dispatch(addCompanyToRedux(response.data));
      return response.data;
    });
};
